module.exports = "<div id=\"content\">\r\n    <app-user-nav></app-user-nav>\r\n    <app-users-list></app-users-list>\r\n</div>\r\n"